import { render } from "./AddLivraison.vue?vue&type=template&id=38f9a13b&scoped=true&ts=true"
import script from "./AddLivraison.vue?vue&type=script&lang=ts"
export * from "./AddLivraison.vue?vue&type=script&lang=ts"

import "./AddLivraison.vue?vue&type=style&index=0&id=38f9a13b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38f9a13b"]])

export default __exports__